module.exports = __webpack_public_path__ + "0f21d39d65eaf7c1252de2fd24955bac.MP3";